import { useContext } from 'react'

import { Tokens } from '../../generated/quicktype/Tokens'
import { TokenContext } from '../view/common/TokenProvider'

export const useToken = (): Tokens => {
  return useContext(TokenContext)
}
